import './bootstrap';
import './vee-validate-custom-rules';

window.toastr = require('toastr');

window.toastr.options = {
  newestOnTop: true,
  progressBar: true,
  showDuration: "500",
};

import Vue from "vue";
import _ from "lodash";
import { Fragment } from 'vue-fragment';

import Multiselect from "VueComponents/Multiselect.vue";
import "vue-multiselect/dist/vue-multiselect.min.css";

import * as BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import TipTap from "@sharpstream/tiptap";
import "@sharpstream/tiptap/dist/tiptap.css";

import * as ResponseHelpers from "Helpers/responses";
import * as PermissionHelpers from "Helpers/permissions";
import * as GtmHelpers from "Helpers/gtm";
import * as MiscHelpers from "Helpers/misc";
import * as FormatterHelpers from "Helpers/formatters";
import * as SocialHelpers from 'Helpers/social';
import * as AsyncComputedHelpers from 'Helpers/async-computed';
import * as TypeSanity from "Lib/type-sanity.js";
import * as ArrayUtil from 'Lib/array-util';

import AsyncComputedMixin from 'VueMixins/Utilities/AsyncComputedMixin';
import VJSModalMixin from "VueMixins/Modals/VjsModal";

import PermissionsDirective from 'VueDirectives/PermissionsDirective';
import SanitiseDirective from 'VueDirectives/SanitiseDirective';
import CooldownDirective from 'VueDirectives/Cooldown/CooldownDirective';

import "vue-masonry-css";

import TimbreCookiesList from 'VueComponents/TimbreCookiesList';

import VjsModal from 'VueModals/VjsModal';
import SsCheckbox from 'VueComponents/SsCheckbox';
import Loader from "VuePartials/Loader";

// vv setup for globally useful validators
import { ConfiguredVeeValidator } from './vee-validate-custom-rules';

Vue.use(ConfiguredVeeValidator);

import VModal from "vue-js-modal";
import ModalCloseButton from "VueComponents/ModalCloseButton";
import BasicPortlet from "VueComponents/BasicPortlet";

import VTooltip from "v-tooltip";

window.Vue = Vue;
window._ = _;

const moment_duration_format_setup = require("moment-duration-format");
moment_duration_format_setup(window.moment);

// for the demo at '/vjs-modal-demo'
import VjsModalDemo from 'VueComponents/Demo/VjsModalDemo';
Vue.component('vjs-modal-demo', VjsModalDemo);
import RadioGroupDemo from 'VueComponents/Demo/RadioGroupDemo';
Vue.component('radio-group-demo', RadioGroupDemo);
import StickySlotDemo from 'VueComponents/Demo/StickySlotDemo';
Vue.component('sticky-slot-demo', StickySlotDemo);
import MultiselectDemo from 'VueComponents/Demo/MultiselectDemo';
Vue.component('multiselect-demo', MultiselectDemo);

// register global components
Vue.use(BootstrapVue);
Vue.component("multiselect", Multiselect);
Vue.component('fragment', Fragment);
Vue.component('timbre-cookies-list', TimbreCookiesList);
Vue.component('vjs-modal', VjsModal);
Vue.component('ss-checkbox', SsCheckbox);
Vue.component('loader', Loader);
Vue.component('tip-tap', TipTap);

import QuickAlertModal from 'VueComponents/VJSModals/QuickAlertModal';
import QuickAlertMixin from 'VueComponents/VJSModals/QuickAlertMixin';
Vue.component('quick-alert-modal', QuickAlertModal);
Vue.mixin(QuickAlertMixin);

// register global lib/helper fns
for (const [k, f] of [
  ...Object.entries(GtmHelpers),
  ...Object.entries(PermissionHelpers),
  ...Object.entries(ResponseHelpers),
  ...Object.entries(MiscHelpers),
]) {
  window[k] = f;
}

window.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute(`content`);

/* eslint-disable snakecasejs/snakecasejs */
// EventBus
export const EventBus = new Vue();
window.EventBus = EventBus;

Vue.use(VModal);
Vue.component("modal-close-button", ModalCloseButton);
Vue.component("basic-portlet", BasicPortlet);
Vue.use(VTooltip);

Vue.mixin({
  methods: {
    ...GtmHelpers,
    ...MiscHelpers,
    ...PermissionHelpers,
    ...ResponseHelpers,
    ...FormatterHelpers,
    ...SocialHelpers,
    ...AsyncComputedHelpers,
    ...ArrayUtil,
    ...(Object.entries(TypeSanity)
      .filter(exported => typeof exported[1] === `function`) // filter for functions only
      .reduce((output_obj, [export_key, export_value]) => ({ // construct a new object using these functions
        ...output_obj,
        [export_key]: export_value,
      }), {})),
  },
});
/* eslint-enable snakecasejs/snakecasejs */
Vue.mixin(AsyncComputedMixin);
Vue.mixin(VJSModalMixin);
Vue.directive('perms', PermissionsDirective);
Vue.directive('sanitise', SanitiseDirective);
Vue.directive('cooldown', CooldownDirective);

// probably a smarter way to do this, but for now we'll just stick
// stuff directly on the prototype
Vue.prototype.$missing_image_path = '/build/media/misc/no-image.png';

require('./vue-loader');
